import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Divider } from 'semantic-ui-react';
import styled from 'styled-components';
import BillStornoSearchView from 'components/bill-storno/BillStornoSearchView';
import { RouterProps } from 'react-router';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import BillStornoTableView from 'components/bill-storno/BillStornoTableView';
import { BillSearchResponse } from 'ts-types/api.types';
import { StornoType } from 'ts-types/api.enums';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
  stornoType: StornoType
}

interface State {
  bills: Array<BillSearchResponse>,
  stornoType: StornoType,
  billsLoading: boolean
}

class BillStornoView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      bills: [],
      stornoType: props.stornoType,
      billsLoading: false
    }
  }

  onStornoTypeChange = (stornoType: StornoType) => {
    this.setState({
      stornoType: stornoType
    })
  };

  onFilterBills = (bills: Array<BillSearchResponse>) => {
    this.setState({
      bills: bills
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  render(): React.ReactNode {

    const {bills, stornoType, billsLoading} = this.state;
    const {currentPatient, onPatientRefresh, getMessage} = this.props;


    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.cancelBill")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledPraxSegment>
            <BillStornoSearchView
                currentStornoType={stornoType}
                currentPatient={currentPatient}
                onFilterBills={this.onFilterBills}
                onStornoTypeChange={this.onStornoTypeChange}
                onBillsLoadingChange={this.onBillsLoadingChange}
            />
            <Divider/>
            <BillStornoTableView
                bills={bills}
                currentStornoType={stornoType}
                billsLoading={billsLoading}
                currentPatient={currentPatient}
                onPatientRefresh={onPatientRefresh}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(BillStornoView)));
